import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import { useDispatch } from "react-redux";
import { addCMSData } from "../redux/actions/cmsActions";

const SingletonModelForm = ({ baseData, onClose, setMode, lastSingletonIndex, uploadCmsImage }) => {
  const dispatch = useDispatch();

  // Generate next singleton index (starts from 1)
  const nextIndex = lastSingletonIndex ? lastSingletonIndex + 1 : 1;

  const [singletonIndex] = useState(nextIndex);
  const [imageFiles, setImageFiles] = useState({});


  const [formData, setFormData] = useState({
    ...baseData,
    fields: [],   // structure fields (table columns)
    rows: [],     // table rows
  });

  console.log(formData,"formDataformDataformData");
  

  const [newField, setNewField] = useState({
    fieldName: "",
    fieldKey: "",
    fieldType: "string",
  });

  // -------------------------------------------
  // ADD STRUCTURE FIELD
  // -------------------------------------------
  const handleAddField = () => {
    if (!newField.fieldName || !newField.fieldKey) {
      alert("Field Name & Field Key required");
      return;
    }

    setFormData(prev => ({
      ...prev,
      fields: [...prev.fields, { ...newField }],
      rows: [], // reset rows when structure changes
    }));

    setNewField({
      fieldName: "",
      fieldKey: "",
      fieldType: "string",
    });
  };

  // -------------------------------------------
  // ADD ROW
  // -------------------------------------------
  const addRow = () => {
    const row = {};
    formData.fields.forEach(f => (row[f.fieldKey] = ""));
    setFormData(prev => ({
      ...prev,
      rows: [...prev.rows, row],
    }));
  };

  // -------------------------------------------
  // UPDATE ROW CELL
  // -------------------------------------------
  const updateCell = (rowIndex, key, value) => {
    const updated = [...formData.rows];
    updated[rowIndex][key] = value;
    setFormData(prev => ({ ...prev, rows: updated }));
  };

  // -------------------------------------------
  // DELETE ROW
  // -------------------------------------------
  const deleteRow = (rowIndex) => {
    setFormData(prev => ({
      ...prev,
      rows: prev.rows.filter((_, i) => i !== rowIndex),
    }));
  };

  // -------------------------------------------
  // RENDER DYNAMIC INPUT
  // -------------------------------------------
  const renderCell = (field, rowIndex) => {
    const value = formData.rows[rowIndex][field.fieldKey];

    switch (field.fieldType) {
      case "string":
      case "number":
        return (
          <input
            type={field.fieldType === "number" ? "number" : "text"}
            className="border p-2 rounded w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            value={value}
            onChange={(e) =>
              updateCell(rowIndex, field.fieldKey, e.target.value)
            }
          />
        );

      case "text":
        return (
          <textarea
            className="border p-2 rounded w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            value={value}
            onChange={(e) =>
              updateCell(rowIndex, field.fieldKey, e.target.value)
            }
          />
        );

      case "boolean":
        return (
          <select
            className="border p-2 rounded w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            value={value}
            onChange={(e) =>
              updateCell(rowIndex, field.fieldKey, e.target.value)
            }
          >
            <option value="">Select</option>
            <option value="true">True</option>
            <option value="false">False</option>
          </select>
        );

      case "color":
        return (
          <input
            type="color"
            className="border p-2 rounded h-10 w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            value={value || "#000000"}
            onChange={(e) =>
              updateCell(rowIndex, field.fieldKey, e.target.value)
            }
          />
        );

      case "image":
        return (
          <input
            type="file"
            accept="image/*"
            className="border p-2 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (!file) return;

              // store file separately
              setImageFiles((prev) => ({
                ...prev,
                [`${rowIndex}_${field.fieldKey}`]: file,
              }));

              // temporary value (for UI only)
              updateCell(rowIndex, field.fieldKey, file.name);
            }}
          />
        );


      default:
        return null;
    }
  };

  console.log(Number(formData.merchantId),"Number(formData.merchantId)");
  
  // -------------------------------------------
  // SUBMIT
  // -------------------------------------------
  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = [];

    for (let rowIndex = 0; rowIndex < formData.rows.length; rowIndex++) {
      const row = formData.rows[rowIndex];
      const singletonIndex = rowIndex + 1;

      for (const field of formData.fields) {
        let fieldValue = row[field.fieldKey] ?? "";

        // 🔥 IMAGE UPLOAD (ONLY WHEN FILE EXISTS)
        if (field.fieldType === "image") {
          const imageKey = `${rowIndex}_${field.fieldKey}`;
          const imageFile = imageFiles[imageKey];

          if (imageFile instanceof File) {
            const fd = new FormData();
            fd.append("image", imageFile);
            fd.append("merchantId", Number(formData.merchantId)); // ✅ REQUIRED

            console.log(fd,"fdfdfd");
            

            const res = await fetch(
              "https://api.rmtechsolution.com/uploadCmsImage",
              {
                method: "POST",
                body: fd, 
              }
            );

            const json = await res.json();

            if (!json.success || !json.imageUrl) {
              alert("Image upload failed");
              return;
            }

            // ✅ SAVE FULL URL
            fieldValue = json.imageUrl;
          } else {
            // ❗ No image selected → skip saving empty value
            continue;
          }
        }

        payload.push({
          merchantId: Number(formData.merchantId),
          modelSlug: formData.modelSlug,
          modelName: formData.modelName,
          fieldName: field.fieldName,
          fieldKey: field.fieldKey,
          fieldType: field.fieldType,
          fieldValue,
          singletonModel: 1,
          singletonModelIndex: singletonIndex,
        });
      }
    }

    dispatch(addCMSData(payload));
    onClose();
  };





  // -------------------------------------------
  // UI
  // -------------------------------------------
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center p-2 sm:p-6 z-50">
      <form
        onSubmit={handleSubmit}
        className="bg-white w-full max-w-5xl rounded-lg p-4 sm:p-6 max-h-[90vh] overflow-y-auto space-y-6"
      >
        <h2 className="text-xl sm:text-2xl font-bold sticky top-0 bg-white py-2">Singleton Model</h2>

        {/* BASIC INFO */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <input
            className="border p-2 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
            value={formData.merchantId}
            onChange={(e) =>
              setFormData({ ...formData, merchantId: e.target.value })
            }
            placeholder="Merchant ID"
          />
          <input
            className="border p-2 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
            value={formData.modelName}
            onChange={(e) =>
              setFormData({ ...formData, modelName: e.target.value })
            }
            placeholder="Model Name"
          />
          <input
            className="border p-2 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
            value={formData.modelSlug}
            onChange={(e) =>
              setFormData({ ...formData, modelSlug: e.target.value })
            }
            placeholder="Model Slug"
          />
        </div>

        {/* BACK TO NORMAL MODEL BUTTON */}
        <button
          type="button"
          onClick={() => {
            setMode("create");
          }}
          className="px-4 sm:px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:shadow-lg transition-all duration-300 flex items-center shadow-lg text-sm sm:text-base"
        >
          ← Create Normal Model
        </button>

        {/* ADD COLUMN */}
        <div className="bg-gray-100 p-3 sm:p-4 rounded-lg">
          <h3 className="font-semibold mb-3 text-sm sm:text-base">Add Table Columns</h3>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3">
            <input
              className="border p-2 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
              placeholder="Field Name"
              value={newField.fieldName}
              onChange={(e) =>
                setNewField({ ...newField, fieldName: e.target.value })
              }
            />
            <input
              className="border p-2 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
              placeholder="Field Key"
              value={newField.fieldKey}
              onChange={(e) =>
                setNewField({ ...newField, fieldKey: e.target.value })
              }
            />
            <select
              className="border p-2 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
              value={newField.fieldType}
              onChange={(e) =>
                setNewField({ ...newField, fieldType: e.target.value })
              }
            >
              <option value="string">String</option>
              <option value="text">Text</option>
              <option value="number">Number</option>
              <option value="boolean">Boolean</option>
              <option value="color">Color</option>
              <option value="image">Image</option>
            </select>
          </div>

          <button
            type="button"
            onClick={handleAddField}
            style={{ marginTop: 20 }}
            className="px-4 sm:px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:shadow-lg transition-all duration-300 flex items-center shadow-lg text-sm sm:text-base"
          >
            Add Column
          </button>
        </div>

        {/* TABLE */}
        {formData.fields.length > 0 && (
          <div className="bg-gray-100 p-3 sm:p-4 rounded-lg overflow-x-auto">
            <h3 className="font-semibold mb-3 text-sm sm:text-base">Table Rows</h3>

            {/* HEADER */}
            <div className="grid grid-cols-[repeat(auto-fit,minmax(120px,1fr))] gap-2 sm:gap-3 border-b pb-2 font-semibold text-xs sm:text-sm">
              {formData.fields.map((f) => (
                <div key={f.fieldKey} className="truncate">{f.fieldName}</div>
              ))}
              <div className="text-center">Actions</div>
            </div>

            {/* ROWS */}
            {formData.rows.map((row, rowIndex) => (
              <div
                key={rowIndex}
                className="grid grid-cols-[repeat(auto-fit,minmax(120px,1fr))] gap-2 sm:gap-3 py-2 border-b items-center text-xs sm:text-sm"
              >
                {formData.fields.map((f) => (
                  <div key={f.fieldKey}>{renderCell(f, rowIndex)}</div>
                ))}

                <button
                  type="button"
                  onClick={() => deleteRow(rowIndex)}
                  className="text-red-600 flex justify-center"
                >
                  <Trash2 size={18} />
                </button>
              </div>
            ))}

            <button
              type="button"
              onClick={addRow}
              className="px-4 sm:px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:shadow-lg transition-all duration-300 flex items-center shadow-lg text-sm sm:text-base"
              style={{ marginTop: 20 }}
            >
              + Add Row
            </button>
          </div>
        )}

        {/* FOOTER */}
        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 sticky bottom-0 bg-white pt-4">
          <button type="button" onClick={onClose} className="px-4 sm:px-6 py-2 border rounded-xl text-sm sm:text-base">
            Cancel
          </button>
          <button type="submit" className="px-4 sm:px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:shadow-lg transition-all duration-300 flex items-center shadow-lg text-sm sm:text-base">
            Save Model
          </button>
        </div>
      </form>
    </div>
  );
};

export default SingletonModelForm;
